import { coatingAndFlooringAttributesSchema } from "../services/formValidation";

export const getProductFormSchema = (categoryId: number) => {
  switch (categoryId) {
    case 8:
      return coatingAndFlooringAttributesSchema;
  }
};

export const createComissionValues = (min: number, max: number) => {
  let arrayOfValues = [];
  let value = min;
  let index = 0;

  while (value < max) {
    arrayOfValues.push({ id: index, name: `${value}%`, value: value });
    value = value + 5;
    index++;
  }

  return arrayOfValues;
};

// ERROR HANDLER
export const handleError = (error: any) => {
  console.error(error.message);
  throw error;
};

export function isWallCoveringOrFloor(category: string): boolean {
  return category === "Revestimientos";
}

export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const shortenText = (text: string, maxLength: number = 50): string => {
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};
